<template>
  <div class="news-template">
    <div class="header"></div>
    <div class="title">
      <h3>中国物品编码中心召开中层干部会议传达学习全国市场监管工作会议精神</h3>
      <h5>2021-01-16 11:47:29 中国物品编码中心办公室 吴彻 <i class="el-icon-reading"></i>37</h5>
    </div>
    <el-divider></el-divider>
    <div class="content">
     <div class="acticle-content" style="padding: 15px;">
               <p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 10px; line-height: 2em; color: rgb(69, 69, 69); text-indent: 2em; font-family: &quot;Microsoft YaHei&quot;, Tahoma, Helvetica, Arial, sans-serif; white-space: normal; background-color: rgb(255, 255, 255);">2021年2月4日上午，中国物品编码中心（以下简称编码中心）召开年终中层干部会议，编码中心主任张成海、副主任罗秋科、总工程师李建辉、纪委书记岳善勇出席了会议，编码中心助理以上干部参加本次会议，会议由罗秋科副主任主持。</p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 10px; line-height: 2em; color: rgb(69, 69, 69); text-indent: 2em; font-family: &quot;Microsoft YaHei&quot;, Tahoma, Helvetica, Arial, sans-serif; white-space: normal; background-color: rgb(255, 255, 255);">会上，张成海主任传达了全国市场监管工作电视电话会议精神，并就编码中心近期重点工作进行部署，提出六点要求：<strong style="box-sizing: border-box;">一是</strong>要强化政治意识，提高政治判断力、提高政治领悟力、提高政治执行力；<strong style="box-sizing: border-box;">二是</strong>要继续抓好核心业务发展，深挖发展潜力；<strong style="box-sizing: border-box;">三是</strong>要转变观念，敢于创新，迎接变化；<strong style="box-sizing: border-box;">四是</strong>要强化目标意识、问题意识和成本意识；<strong style="box-sizing: border-box;">五是</strong>加强作风建设，保持良好的工作状态；六是加强疫情防控，确保廉洁过节。</p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 10px; line-height: 2em; color: rgb(69, 69, 69); text-indent: 2em; font-family: &quot;Microsoft YaHei&quot;, Tahoma, Helvetica, Arial, sans-serif; white-space: normal; background-color: rgb(255, 255, 255);">张成海主任强调，编码中心干部要加强政策研究，边发展、边建设、边应用，找到“牛鼻子”，找准切入点，从粗放式向精细化管理发展，强化成本意识，紧盯目标任务，切实落实“最后一公里”。</p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 10px; line-height: 2em; color: rgb(69, 69, 69); text-indent: 2em; font-family: &quot;Microsoft YaHei&quot;, Tahoma, Helvetica, Arial, sans-serif; white-space: normal; background-color: rgb(255, 255, 255); text-align: center;"><img src="/images/news1.jpg" title="20200204020103.jpg" alt="20200204020103.jpg" style="box-sizing: border-box; border: 0px; vertical-align: middle; display: block; max-width: 100%; height: auto; margin: 0px auto;" data-catchresult="img_catchSuccess"></p><p style="box-sizing: border-box; margin-top: 0px; margin-bottom: 10px; line-height: 2em; color: rgb(69, 69, 69); text-indent: 2em; font-family: &quot;Microsoft YaHei&quot;, Tahoma, Helvetica, Arial, sans-serif; white-space: normal; background-color: rgb(255, 255, 255); text-align: right;">（编辑：黄雪松）</p><p><br></p>
               </div>
    </div>
    <div class="newsfooter"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      contentText: `&nbsp;&nbsp;本报济南4月17日电  （记者徐锦庚、李蕊）今年是胜利油田发现60周年。位于黄河入海口的胜利油田迄今累计生产原油12.5亿吨，占全国同期陆上原油产量1/5，目前保持年稳产2340万吨以上。`,
    };
  },
};
</script>
<style lang="scss" scoped>
.news-template {
  text-align: center;
  width: 100%;
  font-family: Hiragino Sans GB, Microsoft Yahei, \\5fae\8f6f\96c5\9ed1, SimSun,
    \\5b8b\4f53, Arial;
  .header {
    height: 6em;
    background: #04c9a0;
  }
  h3 {
    font-size: 1.7em;
    margin: 0.7em 0;
  }
  h5 {
    margin: 0.5em 0;
    color: #909399;
  }
  .content {
    width: 75%;
    margin: 0 12%;
    p {
      font-size: 1.2em;
      text-align: left;
      line-height: 2.2;
      margin-bottom: 2em;
      overflow-wrap: break-word;
      word-wrap: break-word;
    }
  }
}
</style>